import { Api } from "../axios-config";
import { IIndice } from "../indice/IndiceService";

//dados get
export interface ITipo_Indice {
    idTipo: number,
    idIndice: number,
    opcoes?: string,
    indice_de_caixa?: boolean,
    data_criacao?: boolean 
    exclusivo?: boolean 

}
export interface ITipo_Indice_Documento {
    idTipo: number,
    idIndice: number,
    opcoes?: string,
    nomeIndice: string,
    idComponente: number,
    indice_de_caixa: boolean,
}

const list = async (): Promise<IIndice[] | Error> => {
    let cnpj = localStorage.getItem('cnpj');
    if (cnpj !== undefined && cnpj !== null && cnpj !== '') {
        try {
            const { data } = await Api.get(`Indice/cnpj?cnpj=${cnpj}&estado=true&listar=true`);

            if (data) {
                return data;
            }

            return new Error('Erro ao listar os registros');
        } catch (error) {
            console.error(error);

            //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
            return new Error((error as { message: string }).message || 'Erro ao listar os registros');
        }
    } else {
        return new Error("Selecione um cliente");
    }
};

const create = async (dados: ITipo_Indice[]) => {
    try {
        const { data } = await Api.post<ITipo_Indice>('Tipo_indice', dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getByIdTipo = async (idTipo: number, indice_de_caixa?: boolean): Promise<ITipo_Indice_Documento[] | Error> => {
    try {
        var endpoint = "";

        if (indice_de_caixa === undefined || indice_de_caixa === null) {
            endpoint = `/Tipo_indice/pesquisar?idTipo=${idTipo}`;
        } else {
            endpoint = `/Tipo_indice/pesquisar?idTipo=${idTipo}&indice_caixa=${indice_de_caixa}`;
        }
        const { data } = await Api.get(endpoint);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const getIndicesCaixaByIdTipo = async (idTipo: number[], idCaixa?: string): Promise<Omit<ITipo_Indice_Documento, 'idTipo'>[] | Error> => {
    try {
        var stringPesquisa = "/Tipo_indice/pesquisarPorLista";
        if(idCaixa !== null && idCaixa !== undefined && idCaixa !== "nova"){ stringPesquisa = `/Tipo_indice/pesquisarPorLista?idCaixa=${idCaixa}`}

        const { data } = await Api.post(stringPesquisa, idTipo);
        
        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const update = async (dados: ITipo_Indice[]): Promise<void | Error> => {//colocar [] na tipagem para receber um array em vez de apenas um objeto
    try {
        await Api.put('Tipo_indice', dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};


export const Tipo_Indice_Service = {
    list,
    create,
    update,
    getByIdTipo,
    getIndicesCaixaByIdTipo,
}